// Per-error_id mock data factories. Each factory returns
// `{message_key, data}` where `data` matches the shape the render component
// expects (`data.result[*].error_id`, plus whatever per-row fields the
// component reads). Builders only need to populate enough fields to render
// without crashing — placeholder values like 'RS 12345', '100yr', 0.5 are
// fine since the modal only previews layout, not real numbers.
//
// Builders are merged from per-domain chunks (see ./mocks/) so 5 agents could
// be assigned non-overlapping batches without stepping on each other.

import {floodwayMocks} from './mocks/floodwayMocks';
import {crossSectionMocks} from './mocks/crossSectionMocks';
import {structureMocks} from './mocks/structureMocks';
import {flowOutputMocks} from './mocks/flowOutputMocks';
import {compareSurveyMocks} from './mocks/compareSurveyMocks';

const DEFAULT_GLOBAL_VARIABLES = {
    has_floodway: true,
    has_output: true,
};

const COMMON_ROW = {
    cross_section: 'RS 12345',
    profile: '100yr',
};

// Last-resort fallback for codes nobody mocked yet. Renders an empty-ish row
// so the component at least mounts without exception.
const fallback = (errorId, messageKey) => ({
    message_key: messageKey,
    data: {
        global_variables: {...DEFAULT_GLOBAL_VARIABLES},
        result: [
            {
                error_id: errorId,
                error_message: `Preview placeholder for ${errorId} — no per-field mock builder registered yet.`,
                data: [{...COMMON_ROW}],
            },
        ],
    },
});

const builders = {
    ...floodwayMocks,
    ...crossSectionMocks,
    ...structureMocks,
    ...flowOutputMocks,
    ...compareSurveyMocks,
};

export function buildMessageMock(errorId, messageKey) {
    const builder = builders[errorId];
    if (typeof builder === 'function') return builder(messageKey);
    return fallback(errorId, messageKey);
}

export function hasMessageMock(errorId) {
    return typeof builders[errorId] === 'function';
}

export const MOCK_COMMON = {
    DEFAULT_GLOBAL_VARIABLES,
    COMMON_ROW,
};
